(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 11748:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./locale": 89234,
	"./locale.js": 89234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11748;

/***/ }),

/***/ 83236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(85612);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ login_Login; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./components/shared/Modal.jsx
var Modal = __webpack_require__(97391);
// EXTERNAL MODULE: ./components/shared/Button.tsx
var Button = __webpack_require__(22692);
// EXTERNAL MODULE: ./components/shared/FormInput.jsx
var FormInput = __webpack_require__(86232);
// EXTERNAL MODULE: ./lib/api.ts
var api = __webpack_require__(74390);
// EXTERNAL MODULE: ./domain/constants.js
var constants = __webpack_require__(10681);
// EXTERNAL MODULE: ./lib/yup.ts
var lib_yup = __webpack_require__(6716);
// EXTERNAL MODULE: ./wordings-and-errors/errors-messages.js
var errors_messages = __webpack_require__(17481);
;// CONCATENATED MODULE: ./domain/notifications/validation.js



var sendRejectNotificationValidator = lib_yup/* default.object */.Z.object({
    email: lib_yup/* default.string */.Z.string().email().required(),
    notes: lib_yup/* default.string */.Z.string().required(),
    transferRequestId: lib_yup/* default.string */.Z.string().required()
});
var sendSubmittedNotificationValidator = lib_yup/* default.object */.Z.object({
    programId: lib_yup/* default.number */.Z.number().integer().positive().max(constants/* MAX_INTEGER_VALUE */.P).typeError(errors_messages/* default.required_field.message */.Z.required_field.message).required(),
    transferRequestId: lib_yup/* default.string */.Z.string().required()
});
var sendEmailForgotPasswordValidator = lib_yup/* default.object */.Z.object({
    email: lib_yup/* default.string */.Z.string().email().required()
});
var sendEmailVerificationValidator = lib_yup/* default.object */.Z.object({
    email: lib_yup/* default.string */.Z.string().email().required()
});
var sendInviteValidator = lib_yup/* default.object */.Z.object({
    email: lib_yup/* default.string */.Z.string().email().required(),
    inviterEmail: lib_yup/* default.string */.Z.string().email().required()
});
var sendPaidNotificationValidator = lib_yup/* default.object */.Z.object({
    email: lib_yup/* default.string */.Z.string().email().required(),
    transferRequestId: lib_yup/* default.string */.Z.string().required()
});
var sendRequiresChangeNotificationValidator = lib_yup/* default.object */.Z.object({
    email: lib_yup/* default.string */.Z.string().email().required(),
    transferRequestId: lib_yup/* default.string */.Z.string().required(),
    notes: lib_yup/* default.string */.Z.string().required()
}).required();
var sendApprovedNotificationValidator = lib_yup/* default.object */.Z.object({
    encryptedEmail: lib_yup/* default.string */.Z.string().required(),
    transferRequestId: lib_yup/* default.string */.Z.string().required(),
    expectedTransferDate: lib_yup/* default.string */.Z.string().required()
}).required();
var sendCreatedNotificationValidator = lib_yup/* default.object */.Z.object({
    email: lib_yup/* default.string */.Z.string().email().required(),
    transferRequestId: lib_yup/* default.string */.Z.string().required(),
    expectedTransferDate: lib_yup/* default.string */.Z.string().required()
}).required();
var sendCreatedDrafNotificationValidator = lib_yup/* default.object */.Z.object({
    email: lib_yup/* default.string */.Z.string().email().required(),
    hasAccount: lib_yup/* default.boolean */.Z.boolean().required(),
    transferRequestId: lib_yup/* default.string */.Z.string().required(),
    amount: lib_yup/* default.string */.Z.string(),
    programCurrency: lib_yup/* default.array */.Z.array()
}).required();
var sendBatchPaidNotificationValidator = lib_yup/* default.array */.Z.array(lib_yup/* default.string */.Z.string()).min(1).required();
var sendSetDefaultWalletConfirmationValidator = lib_yup/* default.object */.Z.object({
    id: lib_yup/* default.number */.Z.number().integer().positive().max(constants/* MAX_INTEGER_VALUE */.P).required(),
    userId: lib_yup/* default.number */.Z.number().integer().positive().max(constants/* MAX_INTEGER_VALUE */.P).required(),
    email: lib_yup/* default.string */.Z.string().email().required()
}).required();
var sendDefaultWalletReminderValidator = lib_yup/* default.object */.Z.object({
    email: lib_yup/* default.string */.Z.string().email().required(),
    wallets: lib_yup/* default.array */.Z.array().max(1).required()
});
var sendVerificationCodeValidator = lib_yup/* default.object */.Z.object({
    email: lib_yup/* default.string */.Z.string().email().required(),
    code: lib_yup/* default.string */.Z.string().required()
});
var sendWalletVerificationNotificationValidator = lib_yup/* default.object */.Z.object({
    address: lib_yup/* default.string */.Z.string().required(),
    id: lib_yup/* default.number */.Z.number().integer().positive().max(constants/* MAX_INTEGER_VALUE */.P).required(),
    email: lib_yup/* default.string */.Z.string().email().required(),
    userId: lib_yup/* default.number */.Z.number().integer().positive().max(constants/* MAX_INTEGER_VALUE */.P).required()
});
var sendOFACSanctionedNotificationValidator = lib_yup/* default.object */.Z.object({
    userId: lib_yup/* default.number */.Z.number().required(),
    sanctionReason: lib_yup/* default.string */.Z.string().required()
});
var sendTaxFormRejectedNotificationValidator = lib_yup/* default.object */.Z.object({
    emails: lib_yup/* default.array */.Z.array(lib_yup/* default.string */.Z.string().required()).min(1).required(),
    rejectionReason: lib_yup/* default.string */.Z.string().required()
});
var sendTransferPaymentNotFoundNotificationValidator = lib_yup/* default.object */.Z.object({
    emails: lib_yup/* default.array */.Z.array(lib_yup/* default.string */.Z.string().required()).min(1).required(),
    transferRequestsIds: lib_yup/* default.array */.Z.array(lib_yup/* default.string */.Z.string().required()).min(1).required()
});

;// CONCATENATED MODULE: ./components/Authentication/ForgotPasswordModal.jsx












var ForgotPasswordModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var ref = (0,react.useState)(), submitErrors = ref[0], setSubmitErrors = ref[1];
    var ref1 = (0,react.useState)(false), showSuccess = ref1[0], setShowSuccess = ref1[1];
    var ref2 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            email: ""
        },
        resolver: (0,yup/* yupResolver */.X)(sendEmailForgotPasswordValidator)
    }), register = ref2.register, handleSubmit = ref2.handleSubmit, _formState = ref2.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, clearErrors = ref2.clearErrors;
    var handleFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var ref, loginError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSubmitErrors();
                        return [
                            4,
                            api/* api.post */.h.post("/auth/forgot-password", (0,_object_spread/* default */.Z)({}, values))
                        ];
                    case 1:
                        ref = _state.sent(), loginError = ref.error;
                        if (loginError) {
                            return [
                                2,
                                setSubmitErrors(loginError.errors)
                            ];
                        }
                        return [
                            2,
                            setShowSuccess(true)
                        ];
                }
            });
        });
        return function handleFormSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClose = function() {
        onClose(false);
        clearErrors();
        setShowSuccess(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        open: open,
        onModalClosed: handleClose,
        children: [
            !showSuccess && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-lg font-medium text-gray-900 mb-16 text-center",
                        children: "Forgot password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        noValidate: true,
                        onSubmit: handleSubmit(handleFormSubmit),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-16",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* TextInput */.oi, (0,_object_spread/* default */.Z)({
                                    id: "email",
                                    type: "email",
                                    autoComplete: "email",
                                    label: "Your email address",
                                    error: errors.email || (submitErrors === null || submitErrors === void 0 ? void 0 : submitErrors.email)
                                }, register("email")))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row pt-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        variant: "outline",
                                        className: "mr-3",
                                        onClick: handleClose,
                                        loading: isSubmitting,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        variant: "primary",
                                        type: "submit",
                                        loading: isSubmitting,
                                        disabled: isSubmitting,
                                        children: "Next"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showSuccess && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-lg font-medium text-gray-900 mb-16 text-center",
                        children: "Please check your email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-gray-500 text-sm text-center mb-8",
                        children: "We’ve sent you an email to reset your password if there’s a matched account in our system. Follow the instructions in the email to complete the process."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Authentication_ForgotPasswordModal = (ForgotPasswordModal);

// EXTERNAL MODULE: ./domain/auth/validation.js
var validation = __webpack_require__(61205);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/CheckIcon.js
var CheckIcon = __webpack_require__(58057);
;// CONCATENATED MODULE: ./components/Authentication/ResetPasswordModal.jsx













var ResetPasswordModal = function(param) {
    var _open = param.open, open = _open === void 0 ? false : _open, onClose = param.onClose, token = param.token;
    var ref = (0,react.useState)(), submitErrors = ref[0], setSubmitErrors = ref[1];
    var ref1 = (0,react.useState)(false), showSuccess = ref1[0], setShowSuccess = ref1[1];
    var ref2 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            password: "",
            passwordConfirm: ""
        },
        resolver: (0,yup/* yupResolver */.X)(validation/* resetPasswordValidator */.T0)
    }), register = ref2.register, handleSubmit = ref2.handleSubmit, _formState = ref2.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, clearErrors = ref2.clearErrors;
    var handleFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var ref, loginError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSubmitErrors();
                        return [
                            4,
                            api/* api.post */.h.post("/auth/reset-password", (0,_object_spread/* default */.Z)({}, values))
                        ];
                    case 1:
                        ref = _state.sent(), loginError = ref.error;
                        if (loginError) {
                            return [
                                2,
                                setSubmitErrors(loginError.errors)
                            ];
                        }
                        return [
                            2,
                            setShowSuccess(true)
                        ];
                }
            });
        });
        return function handleFormSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClose = function() {
        onClose(false);
        clearErrors();
        setShowSuccess(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        open: open,
        onModalClosed: handleClose,
        children: [
            !showSuccess && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-lg font-medium text-gray-900 mb-16 text-center",
                        children: "Reset Password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        noValidate: true,
                        onSubmit: handleSubmit(handleFormSubmit),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* PasswordInput */.WU, (0,_object_spread/* default */.Z)({
                                    id: "password",
                                    label: "Enter new password",
                                    error: errors.password || (submitErrors === null || submitErrors === void 0 ? void 0 : submitErrors.password)
                                }, register("password")))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* PasswordInput */.WU, (0,_object_spread/* default */.Z)({
                                    id: "password-confirm",
                                    label: "Enter new password again",
                                    error: errors.passwordConfirm || (submitErrors === null || submitErrors === void 0 ? void 0 : submitErrors.passwordConfirm)
                                }, register("passwordConfirm")))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "hidden",
                                    id: "token",
                                    value: token,
                                    defaultValue: token
                                }, register("token")))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row mt-16",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        variant: "outline",
                                        className: "mr-3",
                                        onClick: handleClose,
                                        loading: isSubmitting,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        variant: "primary",
                                        type: "submit",
                                        loading: isSubmitting,
                                        disabled: isSubmitting,
                                        children: "Next"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showSuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center flex-col pt-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-green-100 p-3 rounded-full inline-flex items-center justify-center mb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {
                                width: 24,
                                className: "text-green-600"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-gray-900 text-lg font-medium mb-2",
                            children: "Password has been reset"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-gray-500 text-sm text-center mb-6",
                            children: "Please use your new password when you login next time"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                variant: "primary",
                                onClick: handleClose,
                                children: "Close"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Authentication_ResetPasswordModal = (ResetPasswordModal);

// EXTERNAL MODULE: ./node_modules/react-input-verification-code/dist/index.modern.js + 9 modules
var index_modern = __webpack_require__(80494);
// EXTERNAL MODULE: ./lib/classNames.js
var classNames = __webpack_require__(44882);
// EXTERNAL MODULE: ./node_modules/@inlightmedia/react-countdown-timer/lib/index.js
var lib = __webpack_require__(16989);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/luxon/src/luxon.js + 23 modules
var luxon = __webpack_require__(30120);
// EXTERNAL MODULE: ./components/Authentication/securityCodeModal.module.css
var securityCodeModal_module = __webpack_require__(29500);
var securityCodeModal_module_default = /*#__PURE__*/__webpack_require__.n(securityCodeModal_module);
;// CONCATENATED MODULE: ./components/Authentication/SecurityCodeModal.jsx











var SecurityCodeModal = function(param) {
    var _open = param.open, open = _open === void 0 ? false : _open, onClose = param.onClose, _email = param.email, email = _email === void 0 ? "email@email.com" : _email, handleVerifyCode = param.handleVerifyCode, onResend = param.onResend;
    var ref = (0,react.useState)(), submitErrors = ref[0], setSubmitErrors = ref[1];
    var ref1 = (0,react.useState)(), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(), blocked = ref2[0], setBlocked = ref2[1];
    var handleClose = function() {
        setSubmitErrors();
        setLoading(false);
        onClose(false);
    };
    var handleComplete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleVerifyCode(value)
                        ];
                    case 1:
                        error = _state.sent().error;
                        if (error) {
                            return [
                                2,
                                setSubmitErrors(error.message)
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleComplete(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleResend = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            onResend()
                        ];
                    case 1:
                        error = _state.sent().error;
                        if (error) {
                            setLoading(false);
                            return [
                                2,
                                setSubmitErrors(error.message)
                            ];
                        }
                        blockedTimer();
                        setSubmitErrors();
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleResend() {
            return _ref.apply(this, arguments);
        };
    }();
    var blockedTimer = function() {
        setBlocked(true);
        setTimeout(function() {
            return setBlocked(false);
        }, 60000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        open: open,
        onModalClosed: handleClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-lg font-medium text-gray-900 mb-6 text-center",
                children: "Enter 4-digit security code"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mb-8 text-sm text-gray-500 text-center",
                children: [
                    "Please enter a 4-digit security code that was sent to you email address ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-indigo-600",
                        children: [
                            email,
                            "."
                        ]
                    }),
                    " The code is valid for 10 minutes"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,classNames/* classNames */.A)("flex flex-row items-center justify-center", (securityCodeModal_module_default()).customVerificationInput),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.Z, {
                    autoFocus: true,
                    placeholder: false,
                    passwordMask: false,
                    type: "text",
                    onCompleted: handleComplete
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-center text-sm text-red-500 mt-3",
                children: submitErrors
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center justify-center mt-8 pb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mr-3 text-sm text-gray-500",
                        children: "Didn't get an email?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-32 relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                variant: "primary",
                                type: "button",
                                onClick: handleResend,
                                loading: loading,
                                disabled: loading || blocked,
                                children: "Resend"
                            }),
                            blocked && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute -bottom-5 left-1/4 right-1/4 transform",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                    dateTime: luxon/* DateTime.now */.ou.now().plus(60000).toISO(),
                                    style: {
                                        color: "#000000",
                                        fontSize: "14px"
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Authentication/GoogleLogin.jsx + 2 modules
var GoogleLogin = __webpack_require__(53161);
// EXTERNAL MODULE: ./components/Authentication/Provider.tsx
var Provider = __webpack_require__(84913);
// EXTERNAL MODULE: ./components/Authentication/ResendVerificationModal.jsx
var ResendVerificationModal = __webpack_require__(51651);
// EXTERNAL MODULE: ./components/Authentication/Shared.jsx
var Shared = __webpack_require__(75297);
;// CONCATENATED MODULE: ./components/Authentication/Login.tsx




















function Login(param) {
    var redirectAfterLogin = param.redirectAfterLogin;
    var ref, ref1;
    var refresh = (0,Provider/* useAuth */.aC)().refresh;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(), submitErrors = ref2[0], setSubmitErrors = ref2[1];
    var ref3 = (0,react.useState)(false), openModal = ref3[0], setOpenModal = ref3[1];
    var ref4 = (0,react.useState)(false), openVerifyModal = ref4[0], setOpenVerifyModal = ref4[1];
    var ref5 = (0,react.useState)(false), openForgotPassModal = ref5[0], setOpenForgotPassModal = ref5[1];
    var ref6 = (0,react.useState)(!!(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.token) || false), openResetPassModal = ref6[0], setOpenResetPassModal = ref6[1];
    var ref7 = (0,react.useState)(), userData = ref7[0], setUserData = ref7[1];
    var ref8 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            email: "",
            password: ""
        },
        resolver: (0,yup/* yupResolver */.X)(validation/* loginValidator */.a5)
    }), register = ref8.register, handleSubmit = ref8.handleSubmit, watch = ref8.watch, _formState = ref8.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var email = watch("email");
    var handleFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var ref, data, loginError, ref1, ref2, verificationError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSubmitErrors(undefined);
                        return [
                            4,
                            api/* api.post */.h.post("/auth/login", (0,_object_spread/* default */.Z)({}, values))
                        ];
                    case 1:
                        ref = _state.sent(), data = ref.data, loginError = ref.error;
                        setUserData(data);
                        if (!loginError) return [
                            3,
                            4
                        ];
                        if (!((ref1 = loginError.errors) === null || ref1 === void 0 ? void 0 : ref1.verification)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            api/* api.post */.h.post("/auth/send-email-verification", {
                                email: email
                            })
                        ];
                    case 2:
                        ref2 = _state.sent(), verificationError = ref2.error;
                        if (verificationError) {
                            return [
                                2,
                                setSubmitErrors(verificationError.errors)
                            ];
                        }
                        return [
                            2,
                            setOpenModal(true)
                        ];
                    case 3:
                        return [
                            2,
                            setSubmitErrors(loginError.errors)
                        ];
                    case 4:
                        return [
                            2,
                            setOpenVerifyModal(true)
                        ];
                }
            });
        });
        return function handleFormSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCodeSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(code) {
            var ref, verifyError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            api/* api.post */.h.post("/auth/verify-code", {
                                code: code,
                                token: userData.token
                            })
                        ];
                    case 1:
                        ref = _state.sent(), verifyError = ref.error;
                        if (verifyError) {
                            return [
                                2,
                                {
                                    error: verifyError
                                }
                            ];
                        }
                        refresh();
                        if (redirectAfterLogin) {
                            js_cookie/* default.remove */.Z.remove("@PL:fromDraftEmail");
                            return [
                                2,
                                router.push(redirectAfterLogin)
                            ];
                        } else {
                            return [
                                2,
                                router.push("/my-transfer-requests")
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCodeSubmit(code) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleResend = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, verifyError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            api/* api.post */.h.post("/auth/resend-code", {
                                token: userData.token
                            })
                        ];
                    case 1:
                        ref = _state.sent(), verifyError = ref.error;
                        if (verifyError) {
                            return [
                                2,
                                {
                                    error: verifyError
                                }
                            ];
                        }
                        return [
                            2,
                            {}
                        ];
                }
            });
        });
        return function handleResend() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared/* Layout */.A, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full w-full flex flex-col justify-center space-y-6 px-8 md:px-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleLogin/* GoogleLogin */.k, {
                    buttonText: "Login with Google"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-center",
                    children: "or"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    noValidate: true,
                    className: "h-full w-full flex flex-col justify-center space-y-6",
                    onSubmit: handleSubmit(handleFormSubmit),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* TextInput */.oi, (0,_object_spread/* default */.Z)({
                            // @ts-ignore
                            id: "email",
                            type: "email",
                            autoComplete: "email",
                            label: "Email",
                            error: errors.email || (submitErrors === null || submitErrors === void 0 ? void 0 : submitErrors.email)
                        }, register("email"))),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function() {
                                        return setOpenForgotPassModal(true);
                                    },
                                    className: "absolute right-0 text-sm text-indigo-600 font-bold",
                                    children: "Forgot password?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* PasswordInput */.WU, (0,_object_spread/* default */.Z)({
                                    id: "password",
                                    label: "Password",
                                    error: errors.password || (submitErrors === null || submitErrors === void 0 ? void 0 : submitErrors.password)
                                }, register("password")))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "h-full w-full flex flex-col justify-center space-y-6 mt-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        type: "submit",
                                        disabled: isSubmitting,
                                        loading: isSubmitting,
                                        children: "Login"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-center",
                                        children: "or"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* LinkButton */.Q, {
                                        variant: "outline",
                                        href: "/signup",
                                        children: "Sign up"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Authentication_ForgotPasswordModal, {
                    open: openForgotPassModal,
                    onClose: function() {
                        return setOpenForgotPassModal(false);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Authentication_ResetPasswordModal, {
                    open: openResetPassModal,
                    onClose: function() {
                        return setOpenResetPassModal(false);
                    },
                    token: router.query.token
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResendVerificationModal/* ResendVerificationModal */.H, {
                    openModal: openModal,
                    email: email,
                    onModalClosed: function() {
                        return setOpenModal(false);
                    },
                    setSubmitErrors: setSubmitErrors,
                    errorMessage: submitErrors === null || submitErrors === void 0 ? void 0 : (ref1 = submitErrors.verification) === null || ref1 === void 0 ? void 0 : ref1.message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurityCodeModal, {
                    open: openVerifyModal,
                    onClose: function() {
                        setOpenVerifyModal(false);
                    },
                    email: email,
                    handleVerifyCode: handleCodeSubmit,
                    onResend: handleResend
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/login.tsx





var __N_SSP = true;
function login_Login() {
    var ref = (0,react.useState)(null), redirect = ref[0], setRedirect = ref[1];
    (0,react.useEffect)(function() {
        var fromCookie = js_cookie/* default.get */.Z.get("@PL:fromDraftEmail");
        if (!fromCookie) return;
        var parsedFrom = JSON.parse(fromCookie);
        if (parsedFrom === null || parsedFrom === void 0 ? void 0 : parsedFrom.id) {
            var url = "/transfer-requests/".concat(parsedFrom.id, "/edit");
            setRedirect(url);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Login - Protocol Labs Transfer"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {
                redirectAfterLogin: redirect
            })
        ]
    });
}


/***/ }),

/***/ 29500:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customVerificationInput":"securityCodeModal_customVerificationInput__Si3O5"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4444,6949,120,3479,1902,6232,3456,9774,2888,179], function() { return __webpack_exec__(83236); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);